/**
 * Friend requests on home (direct friends ticket 05): one quiet line above Record and Type, beside the raid line.
 * "*name* wants to be friends" for one, "*n* people want to be friends" for more, and **See** opens Friends, where
 * Accept and Decline are. Home reads `GET /api/friends` (beta only) on the live check and hands the requests in;
 * with none there is no line. No toast and no push: the line appears and goes with the live updates.
 */
import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { t } from '../i18n';
import { tPart } from '../bidi-html';
import { go } from '../router';
import { nameOf } from './raid/raid-bits';
import type { FriendRequest } from '../api';

@customElement('friend-request-gate')
export class FriendRequestGate extends LitElement {
  @property({ attribute: false }) requests: FriendRequest[] = [];

  protected createRenderRoot() { return this; }

  render() {
    const n = this.requests.length;
    if (!n) return nothing;
    return html`<div class="raid-gate friend-request-gate" data-kind="request" role="status">
      <span class="raid-gate-line">${n === 1
        ? tPart('friends.wants', 'name', html`<em>${nameOf(this.requests[0].name)}</em>`)
        : t('friends.wantMany', { n })}</span>
      <button class="btn primary raid-gate-go" @click=${() => go('/circle')}>${t('friends.seeRequests')}</button>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap { 'friend-request-gate': FriendRequestGate }
}
